import { createBrowserRouter, redirect } from 'react-router';
import { RootLayout } from '@/app/components/RootLayout';
import { AdminLayout } from '@/app/components/admin/AdminLayout';
import { LandingPage } from '@/app/pages/main/LandingPage';
import { NotFoundPage } from '@/app/pages/main/NotFoundPage';
import { BotExplorePage } from '@/app/pages/explore/BotExplorePage';
import { ChatPage } from '@/app/pages/chat/ChatPage';
import { PurchasePage } from '@/app/pages/dashboard/PurchasePage';
import { VotingPage } from '@/app/pages/voting/VotingPage';
import { DashboardPage } from '@/app/pages/dashboard/DashboardPage';
import { AdminLoginPage } from '@/app/pages/admin/AdminLoginPage';
import { AdminDashboardPage } from '@/app/pages/admin/AdminDashboardPage';
import { AdminCharactersPage } from '@/app/pages/admin/AdminCharactersPage';
import { AdminVotingPage } from '@/app/pages/admin/AdminVotingPage';
import { AdminAnalyticsPage } from '@/app/pages/admin/AdminAnalyticsPage';
import { tokenUtils } from '@/api/axios.config';
import { adminTokenUtils } from '@/api';
import { authService } from '@/api/services/auth.service';
import { useAuthStore } from '@/stores/authStore';

const protectedLoader = async () => {
  const token = tokenUtils.getToken();
  if (!token) return redirect('/');

  const { user } = useAuthStore.getState();
  if (!user) {
    try {
      const profileResponse = await authService.getUserProfile();
      useAuthStore.getState().setUser(profileResponse.data);
    } catch {
      tokenUtils.removeToken();
      return redirect('/');
    }
  }
  return null;
};

const adminLoader = async () => {
  if (!adminTokenUtils.hasToken()) return redirect('/admin/login');
  try {
    await authService.getAdminSession();
    return null;
  } catch {
    adminTokenUtils.removeToken();
    return redirect('/admin/login');
  }
};

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: LandingPage },
      { path: 'explore', Component: BotExplorePage, loader: protectedLoader },
      { path: 'chat/:botId', Component: ChatPage, loader: protectedLoader },
      { path: 'purchase', Component: PurchasePage, loader: protectedLoader },
      { path: 'voting', Component: VotingPage, loader: protectedLoader },
      { path: 'dashboard', Component: DashboardPage, loader: protectedLoader },
      { path: '*', Component: NotFoundPage },
    ],
  },
  {
    path: '/admin',
    children: [
      { path: 'login', Component: AdminLoginPage },
      {
        element: <AdminLayout />,
        loader: adminLoader,
        children: [
          { index: true, Component: AdminDashboardPage },
          { path: 'characters', Component: AdminCharactersPage },
          { path: 'voting', Component: AdminVotingPage },
          { path: 'analytics', Component: AdminAnalyticsPage },
        ],
      },
    ],
  },
]);
